import { Injectable } from '@angular/core';
import { HttpTelemetryEvent, TelemetryService } from './telemetry.service';

@Injectable()
export class NoopTelemetryService extends TelemetryService {
  trackHttpRequest(_event: HttpTelemetryEvent): void {
    // Intentionally no-op for non-development sinks.
  }
}
